import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\HASEE\\Documents\\ChatGPT\\生产项目\\cf-migrations\\nextwork\\build\\quickclaw-pro\\node_modules\\next-intl\\dist\\esm\\production\\navigation\\shared\\BaseLink.js");
